module.exports = __webpack_public_path__ + "img/yao_tu.bf1a6449.png";